var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUnderline = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4667 3.7C13.4667 3.31341 13.7801 3 14.1667 3C14.5533 3 14.8667 3.31341 14.8667 3.7V9.76667C14.8667 12.2112 12.8778 14.2 10.4332 14.2C9.24907 14.2 8.13575 13.7388 7.29841 12.9015C6.46102 12.0641 5.99995 10.9507 6 9.76657V3.7C6 3.31341 6.31341 3 6.7 3C7.08659 3 7.4 3.31341 7.4 3.7V9.76662C7.39995 10.5768 7.71542 11.3386 8.28839 11.9116C8.86132 12.4844 9.62301 12.8 10.4332 12.8C12.1059 12.8 13.4667 11.4392 13.4667 9.76667V3.7ZM6.7 15.6H14.1667C14.5533 15.6 14.8667 15.9134 14.8667 16.3C14.8667 16.6866 14.5533 17 14.1667 17H6.7C6.31341 17 6 16.6866 6 16.3C6 15.9134 6.31341 15.6 6.7 15.6Z",
    fill: "#5C5F62"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnderline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/underline.4c11334a.svg";
export { ForwardRef as ReactComponent };